// extracted by mini-css-extract-plugin
module.exports = {"reported-migrations":"reported-migrations___1vKje"};